export default __webpack_public_path__ + "static/media/Preloader_3.4499b184.gif";